import { Checkbox, setRef, TextField } from '@mui/material';
import Buttons from '../Buttons/Buttons';
import style from './Data.module.css';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import { handlePhonePaste } from '../../utils/utils';
import { useScroll } from 'framer-motion';
import { useEffect, useState } from 'react';

export default function Data({
    name, setName,
    phone, setPhone,
    email, setEmail,
    com, setCom,
    checked1, setChecked1,
    checked2, setChecked2,
    changePage
}) {
    const [buttonDisabled, setButtonDisabled] = useState(true);

    useEffect(() => {
        let enabled = true;

        if (!name.trim()) enabled = false;
        if (!matchIsValidTel(phone)) enabled = false;
        if (!(/^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(email))) enabled = false;
        if (!checked1) enabled = false;
        if (!checked2) enabled = false;

        setButtonDisabled(!enabled);

    }, [name, phone, email, checked1, checked2]);

    const click = () => {
        if (!buttonDisabled) changePage(7);
    }

    return (
        <>
            <div className={style.container}>
                <TextField
                    label="Имя"
                    size="small"
                    fullWidth
                    required
                    value={name}
                    onInput={(e) => setName(e.target.value)}
                    slotProps={{ htmlInput: { maxLength: 32 } }}
                />
                <MuiTelInput
                    label="Телефон"
                    variant="outlined"
                    size="small"
                    defaultCountry="RU"
                    onlyCountries={["RU"]}
                    fullWidth
                    langOfCountryName="ru"
                    value={phone}
                    onInput={(e) => setPhone(e.target.value)}
                    onPaste={(e) => setPhone(handlePhonePaste(e))}
                    required
                    slotProps={{ htmlInput: { maxLength: 16 } }}
                />
                <TextField
                    label="Email"
                    size="small"
                    helperText="Для отправки электронных чеков"
                    fullWidth
                    required
                    value={email}
                    onInput={(e) => setEmail(e.target.value)}
                    slotProps={{ htmlInput: { maxLength: 64 } }}
                />
                <TextField
                    label="Комментарий"
                    size="small"
                    fullWidth
                    multiline
                    minRows={3}
                    maxRows={10}
                    value={com}
                    onInput={(e) => setCom(e.target.value)}
                    slotProps={{ htmlInput: { maxLength: 256 } }}
                />
            </div>
            <div className={style.rules_container}>
                <div className={style.rules_block}>
                    <Checkbox size="large" checked={checked1} onChange={(e) => setChecked1(e.target.checked)} />
                    <div className={style.rules_text}>
                        <p>Я ознакомлен и согласен на обработку <a href="https://kinoroommoscow.ru/personal_page" target="_blank">персональных данных</a>.</p>
                    </div>
                </div>
                <div className={style.rules_block}>
                    <Checkbox size="large" checked={checked2} onChange={(e) => setChecked2(e.target.checked)} />
                    <div className={style.rules_text}>
                        <p>Я согласен с <a href="https://kinoroommoscow.ru/publicoffer" target="_blank">договором оферты</a> и <a href="https://kinoroommoscow.ru/deposit_agreement" target="_blank">офертой о заключении соглашения задатка</a>.</p>
                    </div>
                </div>
            </div>
           <Buttons button1={{ text: "Далее", onClick: click, disabled: buttonDisabled }} button2={{ text: "Назад", onClick: () => changePage(5) }} />
        </>
    )
}
